import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GM_PRICE_APPROVAL, GM_PRICE_APPROVAL_SUCCESS, GM_PRICE_APPROVAL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* gmPriceApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { id, action } = payload.data || {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/other-gm-prices/${id}/approval-action`,
      method: 'POST',
      data: { action },
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: GM_PRICE_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: GM_PRICE_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GM_PRICE_APPROVAL_ERROR, payload: error });
  }
}

export function* watchGmPriceApproval() {
  yield takeEvery(GM_PRICE_APPROVAL, gmPriceApproval);
}

function* gmPriceApprovalSaga() {
  yield all([fork(watchGmPriceApproval)]);
}

export default gmPriceApprovalSaga;
